var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomLooks3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 96 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520 776q44 0 69.5-25.5T615 681v-45q0-26-17-43t-43-17q26 0 43-17t17-43v-45q0-44-25.5-69.5T520 376H392q-19.975 0-33.487 13.518Q345 403.035 345 423.018 345 443 358.8 457t34.2 14h127v65h-55q-17 0-28.5 11.5T425 576q0 17 11.5 28.5T465 616h55v65H392q-19.975 0-33.487 13.518Q345 708.035 345 728.018 345 748 358.8 762t34.2 14h127ZM212 970q-53 0-89.5-36.5T86 844V308q0-53 36.5-89.5T212 182h536q53 0 89.5 36.5T874 308v536q0 53-36.5 89.5T748 970H212Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLooks3);
export default __webpack_public_path__ + "static/media/custom-looks-3.a793e6b1a5baea32f482f01f2a79e66b.svg";
export { ForwardRef as ReactComponent };